import React from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQEditorProps {
  items: FAQItem[];
  onChange: (items: FAQItem[]) => void;
  errors?: string[];
}

const FAQEditor: React.FC<FAQEditorProps> = ({
  items,
  onChange,
  errors,
}) => {
  const handleAdd = () => {
    onChange([...items, { question: '', answer: '' }]);
  };

  const handleChange = (index: number, field: 'question' | 'answer', value: string) => {
    const newItems = [...items];
    newItems[index] = { ...newItems[index], [field]: value };
    onChange(newItems);
  };

  const handleRemove = (index: number) => {
    const newItems = items.filter((_, i) => i !== index);
    onChange(newItems);
  };

  return (
    <div className="form-group mb-3">
      <label className="form-label fw-semibold">よくある質問</label>
      <div className="mb-2">
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={handleAdd}
        >
          <i className="fas fa-plus"></i> 質問を追加
        </button>
      </div>
      <div className="items-container">
        {items.map((item, index) => (
          <div key={index} className="nested-fields mb-3 p-3 border rounded">
            <div className="row">
              <div className="col-11">
                <div className="form-group mb-2">
                  <label className="form-label">質問</label>
                  <input
                    type="text"
                    className={`form-control ${errors ? 'is-invalid' : ''}`}
                    value={item.question}
                    onChange={(e) => handleChange(index, 'question', e.target.value)}
                    placeholder="質問を入力してください"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">回答</label>
                  <textarea
                    className={`form-control ${errors ? 'is-invalid' : ''}`}
                    value={item.answer}
                    onChange={(e) => handleChange(index, 'answer', e.target.value)}
                    rows={3}
                    placeholder="回答を入力してください"
                  />
                </div>
              </div>
              <div className="col-1 d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleRemove(index)}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {errors && errors.length > 0 && (
        <div className="invalid-feedback d-block">{errors.join(', ')}</div>
      )}
    </div>
  );
};

export default FAQEditor;



